<template>
  <div>
    <a-form-model class="basic" :model="form" :rules="rules" ref="baseForm">
      <a-collapse
        :bordered="true"
        expand-icon-position="right"
        :activeKey="[
          '1',
          '2',
          '3',
          '4',
          '5',
          '6',
          '7',
          '8',
          '9',
          '10',
          '11',
          '12',
          '13',
          '14',
          '15',
          '16',
          '17',
          '18',
          '19',
          '20',
          '21',
        ]"
        class="detail-collapse"
      >
        <!-- ===================== 项目基本信息 ===================== -->
        <a-collapse-panel key="1">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                项目基本信息
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <BasicInfo :form="form" :isEditable="isEditable"></BasicInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 权证信息 ===================== -->
        <a-collapse-panel key="2">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">权证信息</div>
            </a-space>
          </template>
          <RightInfo
            :selectHouseList="selectHouseList"
            ref="rightInfo"
          ></RightInfo>
        </a-collapse-panel>

        <!-- ===================== 房源属性信息 ===================== -->
        <a-collapse-panel key="3">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源信息</div>
            </a-space>
          </template>
          <ResourceInfo
            :selectHouseList="selectHouseList"
            :bidApplyWebId="webId"
            :form="form"
            :isEditable="isEditable"
          ></ResourceInfo>
        </a-collapse-panel>

        <!-- ===================== 招租信息 ===================== -->
        <a-collapse-panel key="4">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">招租信息</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <RentalInfo :form="form" :isEditable="isEditable"></RentalInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 承租方需承担的其他费用 ===================== -->
        <a-collapse-panel key="5">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                承租方需承担的其他费用
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <OtherCharges :form="form" :isEditable="isEditable"></OtherCharges>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 押金及租金支付要求 ===================== -->
        <a-collapse-panel key="6">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                押金及租金支付要求
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <PaymentRequirement
              :form="form"
              :isEditable="isEditable"
            ></PaymentRequirement>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 其他说明事项 ===================== -->
        <a-collapse-panel key="7">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                其他说明事项
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <OtherDescription
              :form="form"
              :isEditable="isEditable"
            ></OtherDescription>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 设置优先承租人 ===================== -->
        <a-collapse-panel key="8" v-if="form.hasPriorityLease == 1">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                设置优先承租人
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <PriorityLessee
              :form="form"
              :isEditable="isEditable"
            ></PriorityLessee>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 保证金事项 ===================== -->
        <a-collapse-panel key="9">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">保证金事项</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <Paybond :form="form" :isEditable="isEditable"></Paybond>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 承租资格条件 ===================== -->
        <a-collapse-panel key="10">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                承租资格条件
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <Prerequisites
              :form="form"
              :isEditable="isEditable"
            ></Prerequisites>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 公告时间 ===================== -->
        <a-collapse-panel key="11">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">公告时间</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <AnnouncementTime
              :form="form"
              :isEditable="isEditable"
            ></AnnouncementTime>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 招租流程 ===================== -->
        <a-collapse-panel key="12">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">招租流程</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <LeaseProcess :form="form" :isEditable="isEditable"></LeaseProcess>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 竞价参数设置（多次报价） ===================== -->
        <a-collapse-panel
          key="13"
          v-if="
            form.transactionModeType == 1 &&
            form.transactionMode == 1 &&
            form.onlineBiddingMode == 1
          "
        >
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                竞价参数设置（多次报价）
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <RepeatedOffer
              :form="form"
              :startingPrice="startingPrice"
              :isEditable="isEditable"
            ></RepeatedOffer>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 竞价参数设置（一次报价） ===================== -->
        <a-collapse-panel
          key="14"
          v-if="
            form.transactionModeType == 1 &&
            form.transactionMode == 1 &&
            form.onlineBiddingMode == 2
          "
        >
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                竞价参数设置（一次报价）
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <OnceOffer
              :form="form"
              :startingPrice="startingPrice"
              :isEditable="isEditable"
            ></OnceOffer>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 竞价参数设置（开放报价） ===================== -->
        <a-collapse-panel
          key="15"
          v-if="form.transactionModeType == 1 && form.transactionMode == 5"
        >
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                竞价参数设置（开放报价）
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <OpenOffer
              :form="form"
              :startingPrice="startingPrice"
              :isEditable="isEditable"
            ></OpenOffer>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 出租方信息 ===================== -->
        <a-collapse-panel key="16">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">出租方信息</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <LessorInfo :form="form" :isEditable="isEditable"></LessorInfo>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 房源封面 ===================== -->
        <a-collapse-panel key="17">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源封面</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <HousingCover :form="form" :isEditable="isEditable"></HousingCover>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 房源图片 ===================== -->
        <a-collapse-panel key="18">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">房源图片</div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <HousingPicture
              :form="form"
              :isEditable="isEditable"
            ></HousingPicture>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 其他公示的附件（对外公示） ===================== -->
        <a-collapse-panel key="19">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div style="font-size: 16px; margin-bottom: 0px">
                其他公示的附件（对外公示）
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <FileAttachment
              :attachmentList="form.publicAttachment"
              :isEditable="isEditable"
            ></FileAttachment>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 材料清单（不对外公示仅用于内部审核） ===================== -->
        <a-collapse-panel key="20">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                材料清单（不对外公示仅用于内部审核）
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <FileAttachment
              :attachmentList="form.materialBillAttachement"
              :isEditable="isEditable"
            ></FileAttachment>
          </a-spin>
        </a-collapse-panel>

        <!-- ===================== 材料补充清单 ===================== -->
        <a-collapse-panel key="21">
          <template v-slot:header>
            <a-space align="center">
              <div class="title_icon"></div>
              <div
                class="ant-descriptions-title"
                style="font-size: 16px; margin-bottom: 0px"
              >
                材料补充清单
              </div>
            </a-space>
          </template>
          <a-spin :spinning="spinning">
            <SupplyCheck :form="form" :isEditable="isEditable"></SupplyCheck>
          </a-spin>
        </a-collapse-panel>
      </a-collapse>
    </a-form-model>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import BasicInfo from "./basicInfo/BasicInfo";
import RightInfo from "./rightInfo/RightInfo";
import ResourceInfo from "./resourceInfo/ResourceInfo";
import RentalInfo from "./rentalInfo/RentalInfo";
import OtherCharges from "./otherCharges/OtherCharges";
import PaymentRequirement from "./paymentRequirement/PaymentRequirement";
import OtherDescription from "./otherDescription/OtherDescription";
import PriorityLessee from "./priorityLessee/PriorityLessee";
import Paybond from "./paybond/Paybond";
import Prerequisites from "./prerequisites/Prerequisites";
import AnnouncementTime from "./announcementTime/AnnouncementTime";
import LeaseProcess from "./leaseProcess/LeaseProcess";
import RepeatedOffer from "./repeatedOffer/RepeatedOffer";
import OnceOffer from "./onceOffer/OnceOffer";
import OpenOffer from "./openOffer/OpenOffer";
import LessorInfo from "./lessorInfo/LessorInfo";
import HousingCover from "./housingCover/HousingCover";
import HousingPicture from "./housingPicture/HousingPicture";
import FileAttachment from "./attachment/FileAttachment";
import SupplyCheck from "./supplyCheck/SupplyCheck";
import { getObligeeDetail } from "@/api/company/Company.js";
import {
  saveBidApply,
  submitBidApply,
  getApplyDetail,
} from "@/api/project/Project.js";
export default {
  props: {
    isEditable: {
      type: Boolean,
      default: () => true,
    },
    isRepublish: {
      type: Boolean,
      default: () => true,
    },
    webId: {
      type: String,
      default: () => undefined,
    },
    selectHouseList: {
      type: Array,
      default: () => [],
    },
  },
  components: {
    BasicInfo,
    RightInfo,
    ResourceInfo,
    RentalInfo,
    OtherCharges,
    PaymentRequirement,
    OtherDescription,
    PriorityLessee,
    Paybond,
    Prerequisites,
    AnnouncementTime,
    LeaseProcess,
    RepeatedOffer,
    OnceOffer,
    OpenOffer,
    LessorInfo,
    HousingCover,
    HousingPicture,
    FileAttachment,
    SupplyCheck,
  },
  computed: {
    startingPrice() {
      return Number(this.form.floorPrice) || 0;
    },
  },
  data() {
    return {
      spinning: false,
      form: {
        //父层传值
        otype: 0,
        webId: undefined,
        //存库
        houseResourceIds:this.selectHouseList,
        //项目基本信息
        projectId: undefined,
        projectName: undefined,
        stateIntentProject: 0,
        rentWay: 2,
        stateOwned: 1,
        onlineSignup: 1,
        //房源地图相关
        longitude: undefined,
        dimension: undefined,
        //招租信息
        leaseTerm: undefined,
        leaseTermUnit: 1,
        floorPrice: undefined,
        floorPriceUnit: 1,
        rentalPriceType: 1,
        rentalBasePriceDisclosureScope: 1,
        rentalBasePriceRangeMin: undefined,
        rentalBasePriceRangeMax: undefined,
        rentalBasePricePublicTime: 1,
        showRentalUnitPrice: 1,
        hasExistPricingBasis: 0,
        pricingBasis: 1,
        pricingBasisOther: undefined,
        rentCount: undefined,
        enterpriseFirstYearPricing: undefined,
        enterprisePricingUnit: 1,
        hasRentAdjustments: 0,
        rentAdjustmentWay: undefined,
        hasRentFreePeriod: 0,
        rentFreePeriod: undefined,
        rentFreePeriodUnit: 2,
        hasRentContainFreePeriod: 1,
        leaseType: [],
        rentalUse: [],
        rentalUseDesc: undefined,
        businessCategories: [],
        parkCategories: [],
        formatRequirements: undefined,
        policyRecommendations: undefined,
        currentSituationDecoration: 3,
        allowRemodeling: 0,
        remodelingDesc: undefined,
        parkingSpaceAvailable: 0,
        numberParkingSpaces: undefined,
        sublease: 0,
        subleaseDesc: undefined,
        //承租方需承担的其他费用
        hasPropertyManagementFee: 0,
        propertyManagementFeeWay: 1,
        propertyManagementFeeWayDesc: undefined,
        propertyManagementFee: undefined,
        propertyManagementFeeUnit: 1,
        utilityFee: 1,
        utilityFeeDesc: undefined,
        paymentSubject: 1,
        //押金及租金支付要求
        hasPayDeposit: 0,
        depositPayRequirement: undefined,
        rentPaymenclaim: 1,
        rentPaymenclaimDesc: undefined,
        //其他说明事项
        hasExistAbove: 0,
        mortgage: 0,
        rentalStatus: 1,
        leaseTermExpireTime: undefined,
        rentalStatusOtherDesc: undefined,
        otherRequirement: undefined,
        hasPriorityLease: 0,
        isRfpEtLr: 0,
        agencyRegistration: 0,
        //保证金事项
        hasPayBond: 1,
        hasPayBondByPriorityHolder: 1,
        bondAmountByPriorityHolder: undefined,
        bondAmount: undefined,
        bondPayDeadlineType: 2,
        otherBondDesc: undefined,
        //承租资格条件
        intentionLeaseRange: [],
        intentionLeaseRangeDesc: undefined,
        qualificationCondition:
          "1.意向承租方应具有良好的财务状况和支付能力；\n2.意向承租方应具有良好商业信用，无不良经营记录；\n3.符合国家法律、行政法规规定的其他条件。",
        supportingServices: [],
        //公告时间
        disclosureMethod: 1,
        disclosurePeriod: 10,
        disclosurePeriodExtend: 14,
        extendWorkingDaysForever: undefined,
        extendWorkingDaysNum: undefined,
        extendedCyclesNumber: undefined,
        //招租流程
        transactionModeType: 1,
        transactionMode: 1,
        onlineBiddingMode: 1,
        hasQualificationAudit: 1,
        otherBidDesc: undefined,
        //竞价参数设置
        minimumIncrement: undefined,
        maximumIncrement: undefined,
        allowStartingQuote: 1,
        timedQuoteDuration: undefined,
        timedQuoteDurationUnit: 2,
        continuousQuoteDuration: undefined,
        continuousQuoteDurationUnit: 3,
        increment: undefined,
        //出租方信息
        hasEntrustRent: 1,
        lessorName: undefined,
        lessorType: 1,
        businessPrincipal: undefined,
        principalContactNumber: undefined,
        certType: 19,
        certNumber: undefined,
        legalPerson: undefined,
        registAddress: undefined,
        hasLessorStateOwned: 1,
        economicTypeLessor: undefined,
        groupDepartmentName: undefined,
        regulatoryAuthorities: undefined,
        email: undefined,
        mailingAddress: undefined,
        personCertType: 0,
        personCertNumber: undefined,
        country: undefined,
        provinceCityRegion: undefined,
        coverPhoto: [],
        projectPhoto: [],
        //其他公示的附件
        publicAttachment: [
          {
            id: 1,
            type: "其他公示的附件",
            files: [],
            uploadType: 301,
          },
        ],
        //材料清单
        materialBillAttachement: [
          {
            id: 1,
            type: "营业执照",
            files: [],
            uploadType: 401,
          },
          {
            id: 2,
            type: "权证材料",
            files: [],
            uploadType: 402,
          },
          {
            id: 3,
            type: "其他具有法律效力的主体资格证明文件",
            files: [],
            uploadType: 403,
          },
          {
            id: 4,
            type: "出租资产涉及共有或设置其他权利的，提供相关权利人同意的书面文件",
            files: [],
            uploadType: 404,
          },
          {
            id: 5,
            type: "合作协议（栏）",
            files: [],
            uploadType: 405,
          },
          {
            id: 6,
            type: "信息发布申请承诺",
            files: [],
            uploadType: 406,
          },
          {
            id: 7,
            type: "定价依据文件",
            files: [],
            uploadType: 407,
          },
        ],
        //材料补充清单
        supplyCheckList: [],
        //设置优先承租人
        priorityHolder: [],
      },
      rules: {
        projectName: [{ required: true, message: "请输入项目名称" }],
        stateIntentProject: [
          { required: true, message: "请选择是否关联意向发布" },
        ],
        rentWay: [{ required: true, message: "请选择出租方式" }],
        stateOwned: [{ required: true, message: "请选择是否为国资" }],
        onlineSignup: [{ required: true, message: "请选择是否在线报名" }],
        leaseTerm: [
          { required: true, message: "请输入租赁期限", trigger: "blur" },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入租赁期限");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("租赁期限必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        floorPrice: [
          {
            required: true,
            message: "请输入出租底价",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              // 1. 基础校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租底价");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              const price = Number(value);
              if (price < 0) {
                return callback("出租底价必须大于等于0");
              }
              //必须是公示出租底价选项再判断是否落于区间
              if (this.form.rentalPriceType == 2) {
                // 2. 取得区间上下限
                const min = Number(this.form.rentalBasePriceRangeMin);
                const max = Number(this.form.rentalBasePriceRangeMax);

                // 3. 只有当上下限都合法时才进行区间判断
                if (!isNaN(min) && min > 0 && !isNaN(max) && max > 0) {
                  if (price < min) {
                    return callback(`出租底价不得低于区间下限（${min}）`);
                  }

                  if (price > max) {
                    return callback(`出租底价不得高于区间上限（${max}）`);
                  }
                }
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        rentalPriceType: [{ required: true, message: "请选择出租价格类型" }],
        rentalBasePriceDisclosureScope: [
          { required: true, message: "请选择出租底价公开范围" },
        ],
        rentalBasePriceRangeMin: [
          {
            required: true,
            message: "请输入出租底价价格区间（下限）",
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租底价价格区间（下限）");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("出租底价价格区间（下限）必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        rentalBasePriceRangeMax: [
          {
            required: true,
            message: "请输入出租底价价格区间（上限）",
            trigger: ["blur", "change"],
          },
          {
            validator: (rule, value, callback) => {
              // 1. 基础校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入出租底价价格区间（上限）");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              const max = Number(value);
              if (max <= 0) {
                return callback("出租底价价格区间（上限）必须大于0");
              }

              // 2. 取下限价格
              const min = Number(this.form.rentalBasePriceRangeMin);

              // 3. 只有存在下限时，才进行 10 倍校验
              if (!isNaN(min) && min > 0) {
                if (max > min * 10) {
                  return callback("出租底价上限不得高于下限价格10倍");
                }

                if (max < min) {
                  return callback("区间价上限不得小于区间价下限");
                }
              }

              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        rentalBasePricePublicTime: [
          { required: true, message: "请选择出租底价公示时间" },
        ],
        showRentalUnitPrice: [
          { required: true, message: "请选择是否公告展示租金单价" },
        ],
        hasExistPricingBasis: [
          { required: true, message: "请选择是否存在定价依据" },
        ],
        pricingBasis: [{ required: true, message: "请选择定价依据说明" }],
        pricingBasisOther: [
          { required: true, message: "请输入定价依据其他说明" },
        ],
        hasRentAdjustments: [
          { required: true, message: "请选择是否涉及租金调整" },
        ],
        rentAdjustmentWay: [{ required: true, message: "请输入租金调整方式" }],
        hasRentFreePeriod: [{ required: true, message: "请选择是否有免租期" }],
        rentFreePeriod: [{ required: true, message: "请输入免租期时间" }],
        hasRentContainFreePeriod: [
          { required: true, message: "请选择租赁期限是否含免租期" },
        ],
        leaseType: [{ required: true, message: "请选择租赁类型" }],
        rentalUse: [{ required: true, message: "请选择租赁用途" }],
        rentalUseDesc: [{ required: true, message: "请输入租赁用途其他说明" }],
        businessCategories: [
          { required: true, type: "array", message: "请选择商业细分业态" },
        ],
        parkCategories: [
          { required: true, type: "array", message: "请选择园区细分业态" },
        ],
        formatRequirements: [{ required: true, message: "请输入业态要求" }],
        currentSituationDecoration: [
          { required: true, message: "请选择装修现状" },
        ],
        allowRemodeling: [{ required: true, message: "请选是否允许装修改造" }],
        remodelingDesc: [{ required: true, message: "请输入装修改造说明" }],
        parkingSpaceAvailable: [
          { required: true, message: "请选择是否有停车位" },
        ],
        numberParkingSpaces: [
          { required: true, message: "请输入停车位个数", trigger: "blur" },
        ],
        sublease: [{ required: true, message: "请选择是否可转租" }],
        hasPropertyManagementFee: [
          { required: true, message: "请选择是否有物业管理费" },
        ],
        propertyManagementFeeWay: [
          { required: true, message: "请选择物业管理费缴纳方式" },
        ],
        propertyManagementFeeWayDesc: [
          { required: true, message: "请输入物业管理费缴纳方式其他说明" },
        ],
        propertyManagementFee: [
          {
            required: true,
            message: "请输入物业管理费金额",
            trigger: "blur",
          },
          {
            validator(rule, value, callback) {
              if (value === "" || value === null || value === undefined) {
                return callback("请输入物业管理费金额");
              }

              if (isNaN(value)) {
                return callback("请输入数字");
              }

              if (Number(value) <= 0) {
                return callback("物业管理费金额必须大于0");
              }
              callback();
            },
            trigger: "blur",
          },
        ],
        utilityFee: [{ required: true, message: "请选择水电气等费用支付情况" }],
        utilityFeeDesc: [
          { required: true, message: "请输入水电气等费用其他说明" },
        ],
        paymentSubject: [{ required: true, message: "请选择服务费付款主体" }],
        hasPayDeposit: [{ required: true, message: "请选择是否支付押金" }],
        depositPayRequirement: [
          { required: true, message: "请输入押金缴纳要求" },
        ],
        rentPaymenclaim: [{ required: true, message: "请选择租金支付要求" }],
        rentPaymenclaimDesc: [
          { required: true, message: "请输入其他租金支付要求" },
        ],
        hasExistAbove: [{ required: true, message: "请选择是否存在以上情况" }],
        mortgage: [{ required: true, message: "请选择是否存抵押情况" }],
        rentalStatus: [{ required: true, message: "请选择房屋状态" }],
        leaseTermExpireTime: [
          { required: true, message: "请输入租赁期限届满时间" },
        ],
        rentalStatusOtherDesc: [
          { required: true, message: "请输入房屋状态其他说明" },
        ],
        hasPriorityLease: [
          { required: true, message: "请选择是否存在优先承租权人" },
        ],
        isRfpEtLr: [
          { required: true, message: "请选择优先承租权人续租是否享有免租期" },
        ],
        agencyRegistration: [{ required: true, message: "请选择是否代办登记" }],
        hasPayBond: [{ required: true, message: "请选择是否缴纳保证金" }],
        hasPayBondByPriorityHolder: [
          { required: true, message: "请选择优先承租权人交纳保证金" },
        ],
        bondAmountByPriorityHolder: [
          { required: true, message: "请输入差额保证金金额" },
          {
            validator: (rule, value, callback) => {
              const startPrice = this.startingPrice;

              // 1️⃣ 必填校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入差额保证金金额");
              }

              // 2️⃣ 数字格式校验
              if (isNaN(value) || Number(value) <= 0) {
                return callback("差额保证金金额必须为大于0的数字");
              }
              // ✅ 通过校验
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        bondAmount: [
          { required: true, message: "请输入保证金金额" },
          {
            validator: (rule, value, callback) => {
              const startPrice = this.startingPrice;

              // 1️⃣ 必填校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入保证金金额");
              }

              // 2️⃣ 数字格式校验
              if (isNaN(value) || Number(value) <= 0) {
                return callback("保证金金额必须为大于0的数字");
              }
              // ✅ 通过校验
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        bondPayDeadlineType: [
          { required: true, message: "请选择保证金缴纳截止时间" },
        ],
        intentionLeaseRange: [
          { required: true, message: "请选择意向承租方范围" },
        ],
        intentionLeaseRangeDesc: [
          { required: true, message: "请输入意向承租范围其他说明" },
        ],
        qualificationCondition: [
          { required: true, message: "请输入潜在承租方应具备的资格条件" },
        ],
        disclosureMethod: [{ required: true, message: "请选择公告披露方式" }],
        disclosurePeriod: [
          { required: true, message: "请输入公告发布期(工作日)" },
        ],
        disclosurePeriodExtend: [
          { required: true, message: "请选择披露期满未征集到意向方" },
        ],
        extendWorkingDaysForever: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 13) {
                if (!value) {
                  return callback("请输入延长工作日时间");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        extendWorkingDaysNum: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 12) {
                if (!value) {
                  return callback("请输入延长工作日时间");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        extendedCyclesNumber: [
          {
            validator: (rule, value, callback) => {
              if (this.form.disclosurePeriodExtend === 12) {
                if (!value) {
                  return callback("请输入延长周期数");
                }
              }
              callback(); // 其他情况直接通过
            },
            trigger: "blur",
          },
        ],
        transactionModeType: [
          { required: true, message: "请选择招租方式类型" },
        ],
        transactionMode: [{ required: true, message: "请选择招租方式" }],
        onlineBiddingMode: [{ required: true, message: "请选择网络竞价模式" }],
        hasQualificationAudit: [
          {
            required: true,
            message: "请选择出租方是否对意向承租方进行资格审核",
          },
        ],
        otherBidDesc: [{ required: true, message: "请输入其他竞价说明" }],
        minimumIncrement: [
          { required: true, message: "请输入加价幅度" },
          {
            validator: (rule, value, callback) => {
              const startPrice = this.startingPrice;

              // 1️⃣ 必填校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入加价幅度");
              }

              // 2️⃣ 数字格式校验
              if (isNaN(value) || Number(value) <= 0) {
                return callback("加价幅度必须为大于0的数字");
              }

              // 3️⃣ 如果存在起始价，则不能超过 5%
              if (startPrice) {
                const max = Number(startPrice) * 0.05;
                if (Number(value) > max) {
                  return callback(`加价幅度不能超过起始价的 5%`);
                }
              }

              // ✅ 通过校验
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        maximumIncrement: [
          { required: true, message: "请输入最高加价倍数" },
          {
            validator: (rule, value, callback) => {
              // 1️⃣ 必填
              if (value === "" || value === null || value === undefined) {
                return callback("请输入最高加价倍数");
              }

              // 2️⃣ 必须是数字
              const num = Number(value);
              if (isNaN(num)) {
                return callback("请输入有效的数字");
              }

              // 3️⃣ 必须大于等于 1
              if (num < 1) {
                return callback("最高加价倍数必须大于 1");
              }

              // ✅ 校验通过
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        allowStartingQuote: [
          { required: true, message: "请选择是否允许以起始价报价" },
        ],
        timedQuoteDuration: [{ required: true, message: "请输入定时报价时长" }],
        timedQuoteDurationUnit: [
          { required: true, message: "请选择定时报价时长单位" },
        ],
        continuousQuoteDuration: [
          { required: true, message: "请输入连续报价周期" },
        ],
        continuousQuoteDurationUnit: [
          { required: true, message: "请选择连续报价周期单位" },
        ],
        increment: [
          { required: true, message: "请输入加价幅度" },
          {
            validator: (rule, value, callback) => {
              const startPrice = this.startingPrice;

              // 1️⃣ 必填校验
              if (value === "" || value === null || value === undefined) {
                return callback("请输入加价幅度");
              }

              // 2️⃣ 数字格式校验
              if (isNaN(value) || Number(value) <= 0) {
                return callback("加价幅度必须为大于0的数字");
              }

              // 3️⃣ 如果存在起始价，则不能超过 5%
              if (startPrice) {
                const max = Number(startPrice) * 0.05;
                if (Number(value) > max) {
                  return callback(`加价幅度不能超过起始价的 5%`);
                }
              }

              // ✅ 通过校验
              callback();
            },
            trigger: ["blur", "change"],
          },
        ],
        hasEntrustRent: [
          { required: true, message: "请选择是否受委托进行招租" },
        ],
        lessorName: [{ required: true, message: "请输入出租方名称" }],
        lessorType: [{ required: true, message: "请选择出租方类型" }],
        businessPrincipal: [{ required: true, message: "请输入出租方联系人" }],
        principalContactNumber: [
          { required: true, message: "请输入出租方联系人电话" },
        ],
        certType: [{ required: true, message: "请选择出租方证件类别" }],
        certNumber: [{ required: true, message: "请输入出租方证件号码" }],
        legalPerson: [{ required: true, message: "请输入出租方法定代表人" }],
        country: [{ required: true, message: "请选择国家" }],
        provinceCityRegion: [
          { required: true, message: "请选择请选择省/市/区（县）" },
        ],
        registAddress: [{ required: true, message: "请输入注册地（地址）" }],
        hasLessorStateOwned: [
          { required: true, message: "请选择出租方是否国资" },
        ],
        economicTypeLessor: [
          { required: true, message: "请选择出租方经济类型" },
        ],
        groupDepartmentName: [{ required: true, message: "请输入所属集团" }],
        regulatoryAuthorities: [{ required: true, message: "请输入监管部门" }],
        email: [{ required: true, message: "请输入电子邮件" }],
        mailingAddress: [{ required: true, message: "请输入通讯地址" }],
        personCertType: [{ required: true, message: "请选择自然人证件类型" }],
        personCertNumber: [{ required: true, message: "请输入出租方证件号码" }],
      },
    };
  },
  mounted() {
    //1.详情查询出所有的历史数据+所有树结构
    //判断是否有webId,有需要调用，form.otpye = 1改为修改 form.webId = webId，最好加个loading
    if (this.webId && this.webId.trim() !== "") {
      this.spinning = true;
      getApplyDetail({ webId: this.webId })
        .then((res) => {
          if (res && res.code === "200") {
            const baseInfo = res.data.baseInfo;
            this.form.otype = 1;
            //  全量覆盖（包括 null）
            Object.keys(baseInfo).forEach((key) => {
              this.form[key] = baseInfo[key];
            });

            // 特殊字段处理
            this.form.provinceCityRegion = [
              baseInfo.registerProvince,
              baseInfo.registerCity,
              baseInfo.registerRegion,
            ].filter(Boolean);

            // 数组兜底（防止组件报错）
            this.form.leaseType = baseInfo.leaseType || [];
            this.form.businessCategories = baseInfo.businessCategories || [];
            this.form.parkCategories = baseInfo.parkCategories || [];
            this.form.intentionLeaseRange = baseInfo.intentionLeaseRange || [];
            this.form.supportingServices = baseInfo.supportingServices || [];

            //权利人信息
            this.form.groupDepartmentName = {
              label: baseInfo.groupDepartmentName,
              value: baseInfo.groupDepartmentCode,
            };
            this.form.regulatoryAuthorities = {
              label: baseInfo.regulatoryAuthorities,
              value: baseInfo.regulatoryAuthoritiesCode,
            };
            this.form.priorityHolder = res.data.priorityHolder;
            //其他公示的附件
            this.form.publicAttachment.find(
              (item) => item.uploadType === 301
            ).files = res.data.publicAttachment.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.publicAttachmentUrl,
              };
            });
            // 营业执照
            this.form.materialBillAttachement.find(
              (item) => item.uploadType === 401
            ).files = res.data.businessLicense.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.businessLicenseUrl,
              };
            });
            // 权证材料
            this.form.materialBillAttachement.find(
              (item) => item.uploadType === 402
            ).files = res.data.warrant.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.warrantUrl,
              };
            });
            // 其他具有法律效力的主体资格证明文件
            this.form.materialBillAttachement.find(
              (item) => item.uploadType === 403
            ).files = res.data.otherLegalDocument.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.otherLegalDocumentUrl,
              };
            });
            // 出租资产涉及共有或设置其他权利的，提供相关权利人同意的书面文件
            this.form.materialBillAttachement.find(
              (item) => item.uploadType === 404
            ).files = res.data.writtenDocument.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.writtenDocumentUrl,
              };
            });
            // 合作协议（栏）
            this.form.materialBillAttachement.find(
              (item) => item.uploadType === 405
            ).files = res.data.cooperationAgreement.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.cooperationAgreementUrl,
              };
            });
            // 信息发布申请承诺
            this.form.materialBillAttachement.find(
              (item) => item.uploadType === 406
            ).files = res.data.releaseCommitmentApplication.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.releaseCommitmentApplicationUrl,
              };
            });
            // 定价依据文件
            this.form.materialBillAttachement.find(
              (item) => item.uploadType === 407
            ).files = res.data.pricingBasisDocument.map((item) => {
              return {
                uid: uuidv4(),
                name: item.fileName,
                status: "done",
                url: item.pricingBasisDocumentUrl,
              };
            });

            // 材料补充清单
            this.form.supplyCheckList = (res.data.supplyCheckList || []).map(
              (item) => {
                return {
                  ...item,
                  attachments: (item.attachments || []).map((file) => ({
                    uid: uuidv4(),
                    name: file.fileName,
                    status: "done",
                    url: file.supplyCheckFileUrl,
                  })),
                };
              }
            );
          } else {
            this.$notification.error({
              message: "跳转详情页失败",
              description: res.msg,
            });

            this.$emit("back");

            this.$nextTick(() => {
              scrollToTop(this, 80);
            });
          }
        })
        .catch((err) => {
          console.error("接口调用异常：", err);
        })
        .finally(() => {
          //缓冲转圈
          this.spinning = false;
        });
    }
  },

  watch: {
    //基础数据中的stateOwned和出租人信息中的hasLessorStateOwned保持一致
    "form.hasLessorStateOwned"(val) {
      this.form.stateOwned = val === undefined ? 0 : val;
    },
    //基础数据中的stateOwned和出租人信息中的hasLessorStateOwned保持一致
    "form.lessorType"(val) {
      if (val != 1) {
        this.form.hasLessorStateOwned = 0;
      }
    },
    //延长周期和时间
    "form.disclosurePeriodExtend"(val) {
      this.$nextTick(() => {
        if (val === 13) {
          this.$refs.baseForm.validateField("extendWorkingDaysForever");
        } else {
          this.$refs.baseForm.clearValidate(["extendWorkingDaysForever"]);
        }
        if (val === 12) {
          this.$refs.baseForm.validateField([
            "extendWorkingDaysNum",
            "extendedCyclesNumber",
          ]);
        } else {
          this.$refs.baseForm.clearValidate([
            "extendWorkingDaysNum",
            "extendedCyclesNumber",
          ]);
        }
      });
    },
    //招租方式1.竞价2.择优3.其他竞价
    "form.transactionModeType"(val) {
      this.syncQualificationAudit();
    },
    "form.transactionMode"(val) {
      this.syncQualificationAudit();
    },
    "form.lessorType": {
      handler(val) {
        this.$refs.baseForm?.clearValidate([
          "lessorName",
          "lessorType",
          "businessPrincipal",
          "principalContactNumber",
          "certType",
          "certNumber",
          "legalPerson",
          "registAddress",
          "hasLessorStateOwned",
          "economicTypeLessor",
          "groupDepartmentName",
          "regulatoryAuthorities",
          "email",
          "mailingAddress",
          "personCertType",
          "personCertNumber",
          "country",
          "provinceCityRegion",
        ]);
      },
    },
    // 受委托进行招租活动
    "form.hasEntrustRent": {
      immediate: true,
      handler(val) {
        // todo开始
        // ⭐核心判断加入页面模式mode,如果是详情则跳过，直接用调用数据
        // if (this.mode === "view") return;
        // todo结束
        //不授权登记
        if (val === 0) {
          // 清除校验错误
          this.$nextTick(() => {
            this.$refs.baseForm?.clearValidate([
              "lessorName",
              "lessorType",
              "businessPrincipal",
              "principalContactNumber",
              "certType",
              "certNumber",
              "legalPerson",
              "registAddress",
              "hasLessorStateOwned",
              "economicTypeLessor",
              "groupDepartmentName",
              "regulatoryAuthorities",
              "email",
              "mailingAddress",
              "personCertType",
              "personCertNumber",
              "country",
              "provinceCityRegion",
            ]);
          });
          //变更为默认权利人信息
          this.form.lessorType = 1;
          this.form.certType = 19;
          getObligeeDetail()
            .then((res) => {
              if (res && res.code === "200") {
                const result = res.data;
                this.form.lessorName = result.obligeeName;
                this.form.legalPerson = result.legalRepresentative;
                this.form.certNumber = result.socialCreditCode;
                this.form.hasLessorStateOwned =
                  result.obligeeStateOwnedEnterprises;
                this.form.economicTypeLessor = result.obligeeEconomicType;
                this.form.groupDepartmentName = {
                  label: result.obligeeAffiliatedGroup,
                  value: result.obligeeAffiliatedGroupCreditCode,
                };
                this.form.regulatoryAuthorities = {
                  label: result.obligeeRegulatoryAuthority,
                  value: result.obligeeRegulatoryAuthorityCreditCode,
                };
              } else {
              }
            })
            .catch((err) => {
              console.error("接口调用异常：", err);
            });
        } else {
        }
      },
    },
  },

  methods: {
    //招租流程网络开放报价检测
    syncQualificationAudit() {
      if (
        this.form.transactionModeType === 1 &&
        this.form.transactionMode === 5
      ) {
        this.form.hasQualificationAudit = 0;
      }
    },

    /** 保存（不强校验） */
    async handleSave() {
      try {
        // 将注册地址映射成
        const provinceCityRegion = this.form.provinceCityRegion || [];
        this.form.registerProvince = provinceCityRegion[0] || undefined;
        this.form.registerCity = provinceCityRegion[1] || undefined;
        this.form.registerRegion = provinceCityRegion[2] || undefined;

        const coverPhoto = this.form.coverPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const projectPhoto = this.form.projectPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 公示附件（301）
        const publicAttachment = this.form.publicAttachment
          .filter((item) => item.uploadType === 301)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 营业执照（401）
        const businessLicense = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 401)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 权证材料（402）
        const warrant = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 402)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 其他具有法律效力的主体资格证明文件（403）
        const otherLegalDocument = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 403)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 出租资产涉及共有或设置其他权利的，提供相关权利人同意的书面文件（404）
        const writtenDocument = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 404)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 合作协议（栏）（405）
        const cooperationAgreement = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 405)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 信息发布申请承诺（406）
        const releaseCommitmentApplication = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 406)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 定价依据文件（407）
        const pricingBasisDocument = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 407)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const res = await saveBidApply({
          ...this.form,
          //房源封面
          coverPhoto,
          //房源图片
          projectPhoto,
          //附件文件
          publicAttachment,
          businessLicense,
          warrant,
          otherLegalDocument,
          writtenDocument,
          cooperationAgreement,
          releaseCommitmentApplication,
          pricingBasisDocument,
          //树结构重构下参数
          groupDepartmentName: this.form.groupDepartmentName?.label || "",
          groupDepartmentCode: this.form.groupDepartmentName?.value || "",
          regulatoryAuthorities: this.form.regulatoryAuthorities?.label || "",
          regulatoryAuthoritiesCode:
            this.form.regulatoryAuthorities?.value || "",
        });

        if (res && res.code === "200") {
          const result = res.data;
          this.form.otype = 1;
          this.form.webId = result;

          // 延迟 500ms，让页面看起来顺滑一点，避免闪屏
          await new Promise((resolve) => setTimeout(resolve, 500));

          this.$notification.success({
            message: `保存成功`,
            description: `进场公开招租申请`,
          });

          return true;
        } else {
          this.$notification.error({
            message: "保存失败",
            description: err?.message,
          });

          return false;
        }
      } catch (err) {
        console.error("接口调用异常：", err);

        this.$notification.error({
          message: "保存失败",
          description: "接口调用异常",
        });
        throw err;
      }
    },

    /** 提交（强校验） */
    async handleSubmit() {
      try {
        // 表单校验（Promise化）
        const { valid, firstErrorMsg } = await new Promise((resolve) => {
          this.$refs.baseForm.validate((valid, errors) => {
            if (valid) {
              resolve({
                valid: true,
                firstErrorMsg: "",
              });
              return;
            }

            // 从 errors 里随便取一个错误
            let msg = "请先完善进场公开招租申请信息";

            if (errors) {
              for (const key in errors) {
                if (errors[key] && errors[key].length > 0) {
                  msg = errors[key][0].message;
                  break; // 取第一个就行
                }
              }
            }

            resolve({
              valid: false,
              firstErrorMsg: msg,
            });
          });
        });

        if (!valid) {
          this.$notification.warning({
            message: "注意",
            description: firstErrorMsg,
            duration: 4,
          });

          return false;
        }

        // 1. 营业执照
        const businessLicenseFile = this.form.materialBillAttachement.find(
          (item) => item.uploadType === 401
        );

        if (
          !businessLicenseFile ||
          this.getUploadedFiles(businessLicenseFile).length === 0
        ) {
          this.$notification.warning({
            message: "注意",
            description: "请上传营业执照",
            duration: 4,
          });
          return false;
        }
        // 2. 权证材料
        const warrantFile = this.form.materialBillAttachement.find(
          (item) => item.uploadType === 402
        );

        if (!warrantFile || this.getUploadedFiles(warrantFile).length === 0) {
          this.$notification.warning({
            message: "注意",
            description: "请上传权证材料",
            duration: 4,
          });
          return false;
        }

        // 3. 合作协议（栏）
        const cooperationAgreementFile = this.form.materialBillAttachement.find(
          (item) => item.uploadType === 405
        );

        if (
          !cooperationAgreementFile ||
          this.getUploadedFiles(cooperationAgreementFile).length === 0
        ) {
          this.$notification.warning({
            message: "注意",
            description: "请上传合作协议（栏）",
            duration: 4,
          });
          return false;
        }

        // 4. 信息发布申请承诺
        const releaseCommitmentApplicationFile =
          this.form.materialBillAttachement.find(
            (item) => item.uploadType === 406
          );

        if (
          !releaseCommitmentApplicationFile ||
          this.getUploadedFiles(releaseCommitmentApplicationFile).length === 0
        ) {
          this.$notification.warning({
            message: "注意",
            description: "请上传信息发布申请承诺",
            duration: 4,
          });
          return false;
        }

        // 将注册地址映射成
        const provinceCityRegion = this.form.provinceCityRegion || [];
        this.form.registerProvince = provinceCityRegion[0] || undefined;
        this.form.registerCity = provinceCityRegion[1] || undefined;
        this.form.registerRegion = provinceCityRegion[2] || undefined;

        const coverPhoto = this.form.coverPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const projectPhoto = this.form.projectPhoto
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 公示附件（301）
        const publicAttachment = this.form.publicAttachment
          .filter((item) => item.uploadType === 301)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 营业执照（401）
        const businessLicense = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 401)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 权证材料（402）
        const warrant = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 402)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 其他具有法律效力的主体资格证明文件（403）
        const otherLegalDocument = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 403)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 出租资产涉及共有或设置其他权利的，提供相关权利人同意的书面文件（404）
        const writtenDocument = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 404)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 合作协议（栏）（405）
        const cooperationAgreement = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 405)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 信息发布申请承诺（406）
        const releaseCommitmentApplication = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 406)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        // 定价依据文件（407）
        const pricingBasisDocument = this.form.materialBillAttachement
          .filter((item) => item.uploadType === 407)
          .flatMap((item) => item.files || [])
          .filter((file) => file.status === "done")
          .map((file) => ({
            name: file.name,
            url: file.url,
          }));

        const res = await submitBidApply({
          ...this.form,
          //房源封面
          coverPhoto,
          //房源图片
          projectPhoto,
          //附件文件
          publicAttachment,
          businessLicense,
          warrant,
          otherLegalDocument,
          writtenDocument,
          cooperationAgreement,
          releaseCommitmentApplication,
          pricingBasisDocument,
          //树结构重构下参数
          groupDepartmentName: this.form.groupDepartmentName?.label || "",
          groupDepartmentCode: this.form.groupDepartmentName?.value || "",
          regulatoryAuthorities: this.form.regulatoryAuthorities?.label || "",
          regulatoryAuthoritiesCode:
            this.form.regulatoryAuthorities?.value || "",
        });
        await new Promise((resolve) => setTimeout(resolve, 300));
        if (!res || res.code !== "200") {
          this.$notification.warning({
            message: `提交失败`,
            description: res.msg,
          });
          return false;
        }

        this.$notification.success({
          message: "提交成功",
          description: "请等待审核结果",
        });

        this.$emit("back");

        this.$nextTick(() => {
          scrollToTop(this, 80);
        });

        return true;
      } catch (err) {
        console.error("接口调用异常：", err);

        this.$notification.warning({
          message: "提交失败",
          description: err?.message || "接口异常",
        });
        throw err;
      }
    },

    //获取上传文件信息
    getUploadedFiles(record) {
      if (!record.files || !record.files.length) return [];
      return record.files.filter((f) => f.status === "done");
    },
  },
};
</script>

<style scoped>
.detail-collapse {
  background: #fff;
}
.detail-collapse /deep/ .ant-collapse-header {
  font-size: 15px;
  font-weight: bold;
}
.detail-collapse /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}

.detail-collapse /deep/ checkbox.ant-checkbox {
  height: 32px !important;
  border-radius: 4px;
}

::v-deep .detail-collapse .ant-form-item {
  margin-bottom: 8px !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
